export default {
  ["Дата начала продаж {date}"]: (date?: string) =>
    `Satışın başlanma tarixi ${date}`,
  ["Закрыть"]: "Bağla",
  ["Рекламный слайдер"]: "Reklam slaydı",
  ["Используйте клавиши стрелок для переключения слайдов."]:
    "Slaydları dəyişdirmək üçün ox düymələrindən istifadə edin.",
  ["Ещё"]: "Daha çox",
  ["Ещё {number}"]: (number?: number) => `${number} dənə daha`,
  ["Убрать"]: "Sil",
  ["Меню"]: "Menyu",
  ["От {min} до {max} символов"]: (data?: { min: number; max: number }) =>
    `${data?.min} - ${data?.max} simvol arası`,
  ["Минимум {count} символ"]: (count?: number) => `Ən az ${count} simvol`,
  ["Выбрать из списка"]: "Siyahıdan seçin",
  ["развернуто"]: "Genişləndirildi",
  ["свернуто"]: "Yığışdırıldı",
  ["Модальное окно"]: "Modal pəncərə",
  ["Выбран"]: "Seçildi",
  ["Не выбран"]: "Seçilmədi",
  ["Свернуть"]: "Yığışdır",
  ["Эксклюзив"]: "Eksklüziv",
  ["Хит продаж"]: "Çox satılan",
  ["Новинка"]: "Yenilik",
  ["Все книги, получившие эту награду"]: "Bu mükafatı qazanan bütün kitablar",
  ["Предыдущий слайд"]: "Əvvəlki slayd",
  ["Следующий слайд"]: "Növbəti slayd",
  ["Оценить книгу на {count} балл из 5"]: (count?: number) =>
    `Kitabı 5 üzərindən ${count} balla qiymətləndirin`,
  ["Снять оценку"]: "Qiymətləndirməni sil",
  ["{star} звезда из 5"]: (star?: number) => `5 üzərindən ${star} ulduz`,
  ["предыдущий таб"]: "Əvvəlki nişan",
  ["следующий таб"]: "Növbəti nişan",
};
